import moment from "moment";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useHistory, useParams } from "react-router";
import { Link } from "react-router-dom";
import { TOPUPS_COLLECTION, USERS_COLLECTION, _TAKA_ } from "../../constants";
import db from "../../firebaseConfig";
import LoadingIndicator from "../layouts/LoadingIndicator";

const TopupDetails = () => {
    const [topup, setTopup] = useState();
    const [profile, setProfile] = useState(null);
    const [isloading, setIsLoading] = useState(true);

    let { id } = useParams();
    const history = useHistory();
    
    useEffect(() => {
        return getData();
    }, []);

    const getData = async () => {
        setIsLoading(true);
        await db.collection(TOPUPS_COLLECTION)
            .doc(id)
            .get()
            .then( async (doc) => {
                await db.collection(USERS_COLLECTION)
                .doc(doc.data()?.userId)
                .get()
                .then(user => {

                    let data = {
                        uid: doc?.id,
                        userId: doc.data()?.userId,
                        userDisplayName: user.data()?.displayName,
                        userEmail: user.data()?.email,
                        userPhotoURL: user.data()?.photoURL,
                        userPhoneNumber: user.data()?.phoneNumber,
                        gameProfileId: doc.data()?.gameProfileId,
                        gameLoginId: doc.data()?.gameLoginId,
                        gameLoginPassword: doc.data()?.gameLoginPassword,
                        paymentNumber: doc.data()?.paymentNumber,
                        paymentMethod: doc.data()?.paymentMethod,
                        game: doc.data()?.game,
                        diamond: doc.data()?.diamond,
                        price: doc.data()?.price,
                        status: doc.data()?.status,
                        // createdAt: doc.data()?.createdAt,
                        createdAt: moment(doc.data().createdAt.toDate().toString()).fromNow(),
                        updatedAt: doc.data()?.updatedAt
                    }
                    setProfile({
                        uid: doc.data()?.userId,
                        displayName: user.data()?.displayName,
                        email: user.data()?.email,
                        photoURL: user.data()?.photoURL
                    });
                    // console.log(data);
                    setTopup(data);
                })
                // updateTopupsFromdata(data);
            });
        setIsLoading(false);
    }

    
    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text);
        return toast.success('Copied to clipboard!', {position: 'bottom-center', className: 'backdrop-filter backdrop-blur-lg bg-opacity-20',id: 'clipboard',});
    }

    return (
        <div className="">
            <div className="flex w-full justify-between bg-blue-400 py-4 px-4 backdrop-filter backdrop-blur-lg bg-opacity-20 overflow-hidden shadow">
                <button onClick={() => history.goBack()} className=" text-gray-200">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16l-4-4m0 0l4-4m-4 4h18" />
                    </svg>
                </button>
                <p className="m-auto inset-0 text-xl font-semibold leading-7 text-center text-gray-200">Topup Details</p>
            </div>
            {
                isloading ? (<LoadingIndicator />) : (
                    <div className="w-full p-6 bg-blue-400 transform transition duration-500 backdrop-filter backdrop-blur-lg bg-opacity-20 overflow-hidden">
                        <div className="w-full justify-between text-sm mt-3">
                            <span className="bg-red-500 text-gray-100 px-2 py-1 rounded-full backdrop-filter backdrop-blur-lg bg-opacity-20 overflow-hidden shadow uppercase">{topup.createdAt}</span>
                            {(topup.status === 'active') ? (<span className="float-right bg-green-200 px-2 rounded-full backdrop-filter backdrop-blur-lg bg-opacity-20 overflow-hidden shadow uppercase">Active</span>) : (<span className="float-right bg-gray-200 px-2 rounded-full backdrop-filter backdrop-blur-lg bg-opacity-20 overflow-hidden shadow uppercase">{topup.status}</span>)}
                        </div>

                        <div className="w-full items-center justify-between mt-3">
                            <div className="flex items-center justify-between">
                                <span className="text-gray-200 text-xl">{topup.diamond}</span>
                                <span className="text-gray-200 text-3xl">{topup.price} <span className="text-4xl">{_TAKA_}</span></span>
                            </div>
                            <hr className="my-2"/>
                            <div className="flex items-center justify-between mt-5 mb-2">
                                <span className="text-gray-200 text-lg">{topup.paymentMethod} - {topup.paymentNumber}</span>
                            </div>
                            <div className="flex items-center space-x-2">
                                <span className="text-sm text-gray-400">GameID : </span>
                                <div className="flex items-center justify-between space-x-2 cursor-pointer" onClick={() => copyToClipboard(topup.gameProfileId)}>
                                    <span className="text-lg text-gray-200">{topup.gameProfileId}</span>
                                    {topup.gameProfileId && (
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                                        </svg>
                                    )}
                                </div>
                            </div>
                            <div className="flex items-center space-x-2">
                                <span className="text-sm text-gray-400">LoginID : </span>
                                <div className="flex items-center justify-between space-x-2 cursor-pointer" onClick={() => copyToClipboard(topup.gameLoginId)}>
                                    <span className="text-lg text-gray-200">{topup.gameLoginId}</span>
                                    {topup.gameLoginId && (
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                                        </svg>
                                    )}
                                </div>
                            </div>
                            <div className="flex items-center space-x-2">
                                <span className="text-sm text-gray-400">Password : </span>
                                <div className="flex items-center justify-between space-x-2 cursor-pointer" onClick={() => copyToClipboard(topup.gameLoginPassword)}>
                                    <span className="text-lg text-gray-200">{topup.gameLoginPassword}</span>
                                    {topup.gameLoginPassword && (
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                                        </svg>
                                    )}
                                </div>
                            </div>
                        </div>

                        <hr className="my-2"/>

                        <div className="flex items-center space-x-3">
                            <img className="rounded-full h-12 w-12" src={topup.userPhotoURL} alt="user_photo"/>
                            <div className="">
                                <div><span className="text-sm text-gray-400">Name: </span><span className="text-lg text-gray-200">{topup.userDisplayName}</span></div>
                                <div><span className="text-sm text-gray-400">Phone: </span><span className="text-lg text-gray-200">{topup.userPhoneNumber}</span></div>
                                <div><span className="text-sm text-gray-400">Email: </span><span className="text-lg text-gray-200">{topup.userEmail}</span></div>
                            </div>
                            <Link to={{pathname: "/chat-room",state: {user: profile}}}><span className="material-icons-outlined text-red-400">chat</span></Link>
                        </div>
                    </div>
                )
            }
        </div>
    );
}

export default TopupDetails;